document.addEventListener('DOMContentLoaded', () => {
  const attachLoadMoreListener = (button) => {
    if (!button) return; // Stop if no button is found

    const clickHandler = (event) => {
      event.preventDefault();
      const button = event.currentTarget;
      const url = button.href;

      // Provide visual feedback
      button.textContent = 'Loading...';
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.7';

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(text, 'text/html');

          const newProducts = htmlDocument.querySelector('[ref="grid"]');
          const newLoadMoreContainer = htmlDocument.querySelector('#load-more-container');
          
          const currentGrid = document.querySelector('[ref="grid"]');
          const currentLoadMoreContainer = document.querySelector('#load-more-container');

          // 1. Append new product items to the grid
          if (newProducts && currentGrid) {
            currentGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);

            // --- START: Re-initialize Wishlist App ---
            // Now, tell the iWishData app to scan the new products
            setTimeout(() => {
              // Step 3: Call the correct iWish.init() function you discovered.
              // This will find the new products and make the wishlist buttons fully functional.
              if (typeof iWish !== 'undefined' && typeof iWish.init === 'function') {
                iWish.init();
              }
            }, 100);
            // --- END: Re-initialize Wishlist App ---
          }

          // 2. Replace the entire "load more" component with the new one
          if (newLoadMoreContainer && currentLoadMoreContainer) {
            currentLoadMoreContainer.innerHTML = newLoadMoreContainer.innerHTML;
            
            // Find the new button inside the updated component and get it ready for the next click
            const newButton = document.querySelector('#load-more');
            attachLoadMoreListener(newButton);
          }
        })
        .catch(error => {
          console.error('Error loading more products:', error);
          button.textContent = 'Show More'; // Restore button on error
          button.style.pointerEvents = 'auto';
          button.style.opacity = '1';
        });
    };
    
    // Use { once: true } to prevent multiple rapid clicks
    button.addEventListener('click', clickHandler, { once: true });
  };

  // Find the first button on the page and attach the listener
  const initialButton = document.querySelector('#load-more');
  attachLoadMoreListener(initialButton);
});